import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ApplicationRoute } from './applicationConfig/application-route';

@NgModule({
  imports: [RouterModule.forRoot(ApplicationRoute)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
